function CTA() {
  return (
    <section id="download" className="py-20 bg-green-600 text-white text-center">
      <h3 className="text-3xl font-bold mb-6">
        Start Improving Your Salah Today
      </h3>
      <button className="bg-white text-green-600 px-8 py-3 rounded-xl font-semibold hover:bg-gray-100 transition">
        Get the App
      </button>
    </section>
  );
}

export default CTA;
